import { Component, Host, h, Prop, Element, State } from '@stencil/core';
import { addIntersectionObserver } from '../../utils/utils';

@Component({
  tag: 'big-card',
  styleUrl: 'big-card.css',
  shadow: true,
})
export class BigCard {
  /**
   * Cards Size
   */
  @Prop() cardSize: string;
  /**
   * Image Type
   */
  @Prop() imageType: string;

  /**
   * Cards Data
   */
  @Prop() cardsData: string;

  /**
   * Background Color
   */
  @Prop() backgroundColor: string;

  /**
   * Text Color
   */
  @Prop() textColor: string;

  /**
   * Padding Top
   */
  @Prop() paddingTop: string;

  /**
   * Padding Bottom
   */
  @Prop() paddingBottom: string;

  /**
   * Background Image Url
   */
  @Prop() backgroundImage: string;

  /**
   * read more button text
   */
  @Prop() readmoreText: string;

  /**
   * read less button text
   */
  @Prop() readlessText: string;

  @Element() el: HTMLElement;

  componentDidLoad() {
    addIntersectionObserver(
      this.el.shadowRoot.querySelector('.big-card-wrapper'),
      () => {
        this.el.shadowRoot.querySelector('.big-card-wrapper').classList.add('animate');
      },
      ['.overlay1', '.overlay2', '.overlay3', '.overlay4', '.overlay5', '.overlay6', '.overlay7', '.overlay8', '.overlay9', '.overlay10', '.overlay11', '.overlay12'],
    );
  }

  @State() showFullDescription: boolean[] = [];

  toggleDescription(index: number) {
    //console.log('index', index);
    //console.log('showFullDescription', this.showFullDescription);
    const newShowFullDescription = [...this.showFullDescription]; // create a new array
    newShowFullDescription[index] = !newShowFullDescription[index]; // update the new array
    this.showFullDescription = newShowFullDescription; // set the new array to the state variable
  }
  render() {
    const cards = JSON.parse(this.cardsData);
    //console.log('Big-Cards', cards);

    const readmoreText = this.readmoreText ? this.readmoreText : 'Read More';
    const readlessText = this.readlessText ? this.readlessText : 'Read Less';
    return (
      <Host>
        <div
          class={`${this.backgroundColor}  flex items-center  justify-center ${this.paddingBottom} ${this.paddingTop} ${this.imageType} container`}
          style={{ backgroundImage: `url(${this.backgroundImage})` }}
        >
          <div class={`big-card-wrapper ${this.cardSize} `}>
            {cards.length > 0 &&
              cards.map(({ title, position, description, buttons, image_url, image_alt }, index) => (
                <div class={`big-card ${this.cardSize} ${this.imageType}`}>
                  <div class={`overlay${index + 1}`}></div>
                  <div class={`big-card-background  ${this.backgroundColor}`}></div>
                  {image_url && (
                    <div class={`big-card-image ${this.imageType}`}>
                      <image-block imageUrl={image_url} imageAlt={image_alt} imageClass={`object-cover w-full h-auto`}></image-block>
                    </div>
                  )}
                  <div class={`big-card-content`}>
                    {title && <h3 class={`text-ui-gray-1 fs-3 font-semibold`}>{title}</h3>}
                    {position && <h6 class={`text-ui-gray-1 fs-2 font-normal`}>{position}</h6>}

                    {description && <div class={`big-card-description ${this.showFullDescription[index] ? '' : 'line-clamp-4'}`} innerHTML={description}></div>}
                    {description && (
                      <button class={`big-card-read-more`} onClick={() => this.toggleDescription(index)}>
                        {this.showFullDescription[index] ? readlessText : readmoreText}
                      </button>
                    )}
                    {buttons !== null && buttons.length > 0 && (
                      <div class="flex gap-12px">
                        {buttons.map(button => (
                          <button-block buttonsData={button}></button-block>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </Host>
    );
  }
}
